export function isPuriel(value: number): string {
  return value > 1 ? "s" : "";
}
